import { render, staticRenderFns } from "./TariffPlanCard.vue?vue&type=template&id=5f068b94&scoped=true&"
import script from "./TariffPlanCard.vue?vue&type=script&lang=js&"
export * from "./TariffPlanCard.vue?vue&type=script&lang=js&"
import style0 from "./TariffPlanCard.vue?vue&type=style&index=0&id=5f068b94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f068b94",
  null
  
)

export default component.exports